import script from "./TwInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwInput.vue?vue&type=script&setup=true&lang=ts"

import "./TwInput.vue?vue&type=style&index=0&id=278222d8&lang=css"

const __exports__ = script;

export default __exports__